//import { tns } from "./node_modules/tiny-slider/src/tiny-slider";
import { tns } from "tiny-slider";

function tinySlider() {
    let sliders = document.querySelectorAll('.ml-slider');
    Array.prototype.slice.call(sliders)
        .forEach(function (slider) {
            let carrusel = tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                //controls: false, //arrow next prev
                controlsContainer: '#controls',
                prevButton: '.previous',
                nextButton: '.next',
                nav: true, //bullets
                navPosition: 'bottom',
                autoHeight: true,
                mouseDrag: true,
                autoplay: true,
                autoplayButton: false,
                autoplayButtonOutput: false,
                autoplayResetOnVisibility: false
            });
        })
}
export { tinySlider }
